import apiFetch from '../../../utils/apiFetch';

const request = async (campaignId, action, payload) => {
  if (!campaignId) return { status: 'inactive-combat' };
  const response = await apiFetch(`/campaigns/${encodeURIComponent(campaignId)}/combat/sap/${action}`, {
    method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload),
  });
  const result = await response.json().catch(() => ({}));
  if (!response.ok && !result.status) throw new Error(response.statusText || 'Sap combat state could not be updated.');
  return result;
};

export const consumeSapAttackRoll = (campaignId, payload) => request(campaignId, 'consume', payload);
export const createSapOnHit = (campaignId, payload) => request(campaignId, 'apply', payload);
